<script lang="ts">
import i3pSubComponent from '@nuxtDatakodeUtils/components/i3p/I3pSubComponent.vue'
import { OpportunityService } from '~/services/opportunity.service'
import { Opportunity } from '~/models/Opportunity'
import OrganizationData = App.Data.Organization.OrganizationData
import OpportunityData = PildomModules.Voirie.Data.OpportunityData
import LikeData = PildomModules.Voirie.Data.LikeData
import UserData = App.Data.User.UserData

export default {
    name: 'OpportunityLikeActions',
    components: {},
    extends: i3pSubComponent,
    props: {
        opportunityData: { type: Object, required: true },
        organizationData: { type: Object, required: true },
    },
    emits: [],
    data() {
        return {
            saving: '',
            opportunityService: null as OpportunityService,
        }
    },

    computed: {
        myOrganization(): OrganizationData {
            return (this.$currentUser() as UserData).organization
        },
        organization(): OrganizationData {
            return this.organizationData as OrganizationData
        },
        like(): LikeData | null {
            return (this.opportunityData as OpportunityData).my_like
        },
    },
    watch: {
        opportunityData() {
            this.initService()
        },
    },
    beforeMount() {
        this.initService()
    },
    methods: {
        initService(): void {
            this.opportunityService = new OpportunityService(new Opportunity(this.opportunityData))
        },
        deleteLike(likeData: LikeData): void {
            this.saving = 'delete'
            this.opportunityService.deleteLike(likeData).then(() => this.refreshData())
        },

        updateLike(value: any): void {
            this.saving = value ? 'accept' : 'deny'
            this.opportunityService.setLike(value).then(() => this.refreshData())
        },
        refreshData(): void {
            this.i3pService.reloadCurrenEntity().then(this.saving = '') // reload panel
            this.i3pService.getIndex() // reload the list
            this.i3pService.getGeojson() // reload the map
        },
    },
}
</script>

<template>
    <template
        v-if="opportunityData.meta.likable && organization.id === myOrganization.id"
    >
        <template v-if="like && like.value !== null">
            <v-btn
                size="small" variant="text" color="secondary" class="mx-1 ml-2"
                @click.prevent="deleteLike(like)"
            >
                <template #prepend>
                    <v-progress-circular
                        v-if="saving === 'delete'"
                        class="mr-2"
                        color="primary"
                        indeterminate
                        size="16"
                        width="2"
                    />
                    <v-icon v-else icon="mdi-delete" />
                </template>
                Supprimer la réponse
            </v-btn>
        </template>
        <template v-else>
            <v-btn
                size="small" variant="text" color="secondary"
                class="mx-1 ml-2" @click.prevent="updateLike(true)"
            >
                <template #prepend>
                    <v-progress-circular
                        v-if="saving === 'accept'"
                        class="mr-2"
                        color="primary"
                        indeterminate
                        size="16"
                        width="2"
                    />
                    <v-icon v-else icon="mdi-check-circle" />
                </template>
                Accepter
            </v-btn>
            <v-btn
                size="small" variant="text" color="secondary"
                class="mx-1 ml-2" @click.prevent="updateLike(false)"
            >
                <template #prepend>
                    <v-progress-circular
                        v-if="saving === 'deny'"
                        class="mr-2"
                        color="primary"
                        indeterminate
                        size="16"
                        width="2"
                    />
                    <v-icon v-else icon="mdi-close-circle" />
                </template>
                Refuser
            </v-btn>
        </template>
    </template>
</template>
